import { Component, OnInit } from '@angular/core';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ParametroEmpresaService } from 'src/app/services/parametro-empresa.service';
import { TipoDescuentoService } from 'src/app/services/tipo-descuento.service';
import { UnidadNegocioService } from 'src/app/services/unidad-negocio.service';
import { unidad_negocio } from 'src/app/shared/object/unidad_negocio.model';
import { SecurityService } from 'src/app/shared/services/security.service';

@Component({
  selector: 'app-reglas-comerciales',
  templateUrl: './reglas-comerciales.component.html',
  styleUrls: ['./reglas-comerciales.component.scss'],
  providers: [SecurityService],
})
export class ReglasComercialesComponent implements OnInit {
  readonly TAB_DESCUENTOS_ESPECIALES = 'Descuentos especiales';
  readonly TAB_DESCUENTOS_MAXIMOS = 'Descuentos máximos';
  readonly TAB_PROMOCIONES = 'Promociones';
  readonly TAB_COMBOS = 'Combos';

  activeTabHeading: string = this.TAB_DESCUENTOS_ESPECIALES;

  constructor(
    private accesolocalstorage: SecurityService,
    private tipoDescuentoService: TipoDescuentoService,
    private parametroEmpresaService: ParametroEmpresaService,
    private messageRendererService: MessageRendererService,
    private unidadNegocioService: UnidadNegocioService
  ) { }

  // Data &  Tmp
  private rutEmpresa: number;

  optionsUnidadesDeNegocio: unidad_negocio[] = [];
  public permiteUnidadNegocio: boolean = false;
  public permiteVerDescuentoTope: boolean = false;
  public promocionesHabilitado: boolean = false;
  public combosHabilitado: boolean = false;

  optionsTipoDescuento: Array<any> = [];
  optionsUndMedida: Array<any> = [];
  optionsFormato: Array<any> = [];
  optionsFormato2: Array<any> = [];
  optionsCategoria: Array<any> = [];
  optionsFamilia: Array<any> = [];

  ngOnInit() {
    this.rutEmpresa = this.accesolocalstorage.getRutEmpresa();

    this.optionsTipoDescuento = this.tipoDescuentoService.GetTiposDescuento();
    this.parametroUnidadNegocio();
    this.parametroVisualizarDescuentoTope();
    this.loadUnidadNegocio();
  }

  onTabActivated(ev: any) {
    // `mdb-tabset` emite `{ el: TabDirective, activeTabIndex: number }`
    const heading = ev && ev.el && ev.el.heading ? ev.el.heading : null;
    if (heading) this.activeTabHeading = heading;
  }

  parametroUnidadNegocio() {
    this.parametroEmpresaService.permiteUnidadNegocio(this.rutEmpresa, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.permiteUnidadNegocio = respuesta.valor_bool;
    });
  }

  parametroVisualizarDescuentoTope() {
    this.parametroEmpresaService.permiteVisualizarDescuentoTope(this.rutEmpresa, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.permiteVerDescuentoTope = respuesta.valor_bool;
    });
  }

  loadUnidadNegocio() {
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        tipo: 1,
      },
    };
    this.optionsUnidadesDeNegocio = [];
    this.unidadNegocioService.obtenerUnidadNegocio(inputParams, ({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsUnidadesDeNegocio = registros.map((unidad_negocio) => ({
        value: unidad_negocio.codigo,
        label: unidad_negocio.nombre,
      }));
    });
  }
}
